import { useCallback, useEffect, useState } from 'react';
import { globalAction } from 'common/actions';
import { useStore } from 'common/store';

interface DataSheetDialogFlag {
  open: boolean;
  dialogId: string;
  cellId?: string | null;
  disableWhenLedgerOpen?: boolean;
  alias?: string;
}

type DataSheetDialogEntry = Omit<DataSheetDialogFlag, 'open'>;

const useDataSheetDialogActions = (isLedger = false) => {
  const [clearSelected, setClearSelected] = useState(false);
  const [{ dialogFlag }, dispatch] = useStore();

  const { openDialogFlag, dialogs } = dialogFlag;

  useEffect(() => {
    if (openDialogFlag && !isLedger) {
      setClearSelected(true);
    }
  }, [openDialogFlag, isLedger]);

  const setDialogFlag = useCallback(
    ({ open, dialogId, cellId, disableWhenLedgerOpen, alias }: DataSheetDialogFlag) => {
      const currentDialogs = (dialogs ?? []) as DataSheetDialogEntry[];
      const newDialogs = open
        ? [...currentDialogs, { dialogId, cellId, disableWhenLedgerOpen, alias }]
        : currentDialogs.filter(({ dialogId: id }) => dialogId !== id);

      const newOpenDialogFlag = newDialogs && newDialogs.length > 0;

      dispatch(
        globalAction.setDialogFlag({
          openDialogFlag: newOpenDialogFlag,
          dialogs: newDialogs,
        })
      );
    },
    [dispatch, dialogs]
  );

  return {
    openDialogFlag,
    dialogs,
    setDialogFlag,
    clearSelectedFlag: clearSelected,
    setClearSelected,
  };
};

export default useDataSheetDialogActions;
